export function containsAll(arr1, arr2) {
  return arr2.every((item) => arr1.includes(item));
}
